import"core-js/modules/es.regexp.exec.js";export var isStringNumeric=function(a){return /^\+?[\d-\s]+$/.test(a)};